import React from "react";

import { useTranslation } from "react-i18next";

import useLocale from "@/hooks/useLocale";
import { getRulesAndRegulationsFileUrl } from "@/utils/rulesAndRegulations";

const Footer = () => {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <div className="bg-[#F0F0F0] pb-[5rem] pt-10">
      <a
        href={getRulesAndRegulationsFileUrl(locale)}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-center text-ford-blue font-roboto font-bold text-[18px] underline cursor-pointer"
        dangerouslySetInnerHTML={{ __html: t("footer.title") }}
      />

      <div className="border-b border-blue mt-4 mb-6 mx-10" />

      <small className="text-center font-roboto w-full block text-[14px]">
        {t("footer.credits")}
      </small>
    </div>
  );
};

export default Footer;
